import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b0d8b7d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar start" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "onlineIndicator" }, null, -1))
const _hoisted_5 = { class: "headline" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"flex-start"}
}
const _hoisted_8 = { class: "message-container" }
const _hoisted_9 = {
  key: 0,
  class: "loading"
}
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = {
  key: 0,
  class: "small op-5"
}
const _hoisted_12 = {
  key: 1,
  class: "quickActionExamples",
  style: {"background-color":"transparent"}
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = ["placeholder", "onKeyup", "disabled"]

import { Chatbot } from '@/entities/domain/Chatbot/Chatbot';
import { Message } from '@/entities/domain/Chatbot/Message';
import Company from '@/entities/domain/Company/Company';
import { MessageTypes, MessageSender } from '@/entities/enums/ChatbotEnums';
import QuizService from '@/services/QuizService';
import GetDocumentElementById from '@/utils/GetDocumentElementById';
import { PropType, nextTick, ref, computed, watch, onMounted } from 'vue';
import DialogComponent from "@/components/Dialog.vue";
import EmailForm from "@/components/Forms/EmailForm.vue";

import SingleMessage from './SingleMessage.vue';
import Typing from '@/components/BaseComponents/Typing.vue';
import Arrow from '@/components/svg/Arrow.vue';
import Location from '@/components/svg/Location.vue';
import PaperPlane from '@/components/svg/PaperPlane.vue';
import Close from '@/components/svg/Close.vue';
import ArrowLeft from '@/components/svg/ArrowLeft.vue';
import DisplayedTexts from '@/entities/domain/DisplayedTexts';
import { QuestionType } from '@/entities/enums/QuizEnums';
import { Answer } from '@/entities/domain/Quiz/Answer';
import { Product } from '@/entities/domain/Match/Product';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatWindow',
  props: {
	company: {
		type: Object as PropType<Company>,
		required: true,
	},
	chatbot: {
		type: Object as PropType<Chatbot>,
		required: true,
	},
	avatar: {
		type: String,
		required: true,
	},
	inputActive: {
		type: Boolean,
		default: true,
	},
	loadOffers: {
		type: Boolean,
		default: false,
	},
	isExpertQuiz: {
		type: Boolean
	},
	searchInput: {
		type: String,
		default: null
	}
},
  emits: ["startQuiz", "hardStartQuiz", "closeChatWindow", "change", "goBack", "messageSend"],
  setup(__props, { emit: __emit }) {

const props = __props

const inputActive = ref(props.inputActive);
const input = ref(null)
const question = ref(props.searchInput ?? "");
const windowHeight = ref(0);
const isDialogOpened = ref(false);
const blockChat = ref(false)
const disableInput = ref(props.chatbot.MessageHistory[props.chatbot.MessageHistory.length - 1]?.QuestionType !== QuestionType.FreeTextInput)
const selectedProduct = ref(null as Product | null);

const chatbotCopy = ref(new Chatbot(props.chatbot));

const emit = __emit

watch(() => props.chatbot, () => {
	chatbotCopy.value = new Chatbot(props.chatbot);
});


watch(() => chatbotCopy, () => {
	emit("change", chatbotCopy.value);
});

watch(() => props.inputActive, () => {
	inputActive.value = props.inputActive;
});

watch(() => props.chatbot.MessageHistory, (newVal, oldVal) => {
	if (newVal.length > 0 && newVal.at(-1)?.Text?.toLowerCase() === "neu laden") {
		blockChat.value = true;
	}


}, { deep: true });

watch(() => chatbotCopy.value.MessageHistory, () => {
	if (chatbotCopy.value.MessageHistory[chatbotCopy.value.MessageHistory.length - 1]?.QuestionType === QuestionType.FreeTextInput) {
		inputActive.value = true;
		nextTick(() => {
			if (input.value) {
				(input.value! as HTMLInputElement).focus();
			}
		});
	}
	else {
		inputActive.value = false;
		question.value = "";
	}
}, { deep: true })

onMounted(() => {
	if (props.loadOffers)
		chatbotCopy.value.getTasteOffers(props.company);

	updateScroll();
	setTimeout(() => {
		if (input.value)
			(input.value as HTMLInputElement).focus();
	}, 200)

	// if seraechInput is set, send the message
	if (props.searchInput) {
		sendMessage();
	}
})

const simplifyText = (text) => {
	return text
		.toLowerCase() // In Kleinbuchstaben umwandeln
		.replace(/[^a-z0-9äöüß]/gi, '') // Entfernen von Satzzeichen und Sonderzeichen
		.replace(/(er|en|e)$/gi, ''); // Einfaches Entfernen von häufigen Suffixen
}

const actionExampleClicked = (example) => {
	question.value = example;
	sendMessage();
}

const sendMessage = async () => {
	if (question.value === "" || !props.company.Token) return;

	// if FreeTextInput from QuizFlow, don't send Message but load next Question
	if (props.isExpertQuiz && chatbotCopy.value.ExpertQuiz?.getCurrentQuestion().Type === QuestionType.FreeTextInput) {

		chatbotCopy.value.isExpertQuizSet = false;

		emit("messageSend");

		// Quiz Question Free Text input defined terms to match
		const freeTextInputMatchingTerms = chatbotCopy.value.ExpertQuiz?.getCurrentQuestion().FreeTextinputMatchingTerms?.split(/[ ,]+/).map(term => term.toLowerCase());

		for (const quizQuestion of chatbotCopy.value.ExpertQuiz.Questions) {
			const searchTerms = question.value.toLowerCase().split(/[ ,]+/);

			// Function to check for term matches in the question text
			const matchesInput = (input, terms) => terms.some(term => input.includes(simplifyText(term)));

			// Checking and updating based on the presence of terms in free text input or answers
			let matchedQuestion = false;
			if (freeTextInputMatchingTerms && matchesInput(quizQuestion.Text?.toLowerCase(), searchTerms) && matchesInput(quizQuestion.Text?.toLowerCase(), freeTextInputMatchingTerms)){
				matchedQuestion = true;
			} else {
				const firstMatchingAnswer = quizQuestion.Answers.find(answer => matchesInput(answer.Text?.toLowerCase(), searchTerms));
				matchedQuestion = !!firstMatchingAnswer;
			}

			if (matchedQuestion && quizQuestion.Skippable !== false) {
				// Update the nextQuestion references before removing the matched question
				const nextQuestion = quizQuestion.Answers[0]?.NextQuestion;
				chatbotCopy.value.ExpertQuiz.Questions = chatbotCopy.value.ExpertQuiz.Questions.map(copyQuestion => {
					copyQuestion.Answers.forEach(copyAnswer => {
						if (copyAnswer.NextQuestion === quizQuestion.Id) {
							copyAnswer.NextQuestion = nextQuestion;
						}
					});
					return copyQuestion;
				}).filter(el => el.Id !== quizQuestion.Id);
			}
		}


		const questionId = chatbotCopy.value.ExpertQuiz?.QuestionIdHistory.at(-1);
		const nextQuestion = chatbotCopy.value.ExpertQuiz?.Questions.find(el => el.Id === questionId)?.Answers[0].NextQuestion;

		const answer = new Answer({
			Id: 123,
			Text: question.value,
			Value: question.value,
			NextQuestion: nextQuestion
		} as Answer);
		chatbotCopy.value.MessageHistory.push({} as Message)
		chatbotCopy.value.SetAnswerForQuiz(props.company, answer, props.company.CompanyQuizConfig.ExpertQuiz, true);

		updateScroll();

		return;
	}
	else {
		QuizService.sendEvent(JSON.stringify({ topicLabel: "Produkte", questionTextVal: "Was für ein Produkt suchen Sie", answerTextVal: question.value }), "freeTextInput")
		chatbotCopy.value.CurrentQuestion = question.value;
	}

	updateScroll();
	question.value = "";

	const result = await chatbotCopy.value.SendMessage(props.company, true, undefined, false);

	setTimeout(() => {
		updateScroll(
			chatbotCopy.value.MessageHistory[chatbotCopy.value.MessageHistory.length - 2].Id
		);
	}, 1)
	if (!result?.Success) return;

	setTimeout(() => {
		chatbotCopy.value.Loading = true;
	}, 3000);

	setTimeout(async () => {

		if (props.company.CompanyQuizConfig.CouponUrl ?? props.company.CompanyQuizConfig.CouponImageUrl) {
			chatbotCopy.value.MessageHistory.push({
				Id: chatbotCopy.value.MessageHistory.length + 1,
				Text: props.company.DisplayedTexts[props.company.CompanyQuizConfig.CouponUrlInfo ?? ""] ?? props.company.CompanyQuizConfig.CouponUrlInfo ?? "Scanne folgenden QR-Code um für Deine Vorteile",
				Type: MessageTypes.IGNOREINHISTORY,
				Sender: MessageSender.WILLI,
			} as Message);

			chatbotCopy.value.MessageHistory.push({
				Id: chatbotCopy.value.MessageHistory.length + 1,
				Type: MessageTypes.COUPON,
				Sender: MessageSender.WILLI,
			} as Message);

			if(props.company.CompanyQuizConfig.CouponUrlInfo2)
				chatbotCopy.value.MessageHistory.push({
					Id: chatbotCopy.value.MessageHistory.length + 1,
					Text: props.company.DisplayedTexts[props.company.CompanyQuizConfig.CouponUrlInfo2] ?? props.company.CompanyQuizConfig.CouponUrlInfo2,
					Type: MessageTypes.IGNOREINHISTORY,
					Sender: MessageSender.WILLI,
				} as Message);
		}

		chatbotCopy.value.MessageHistory.push({
			Id: chatbotCopy.value.MessageHistory.length + 1,
			Text: props.company.DisplayedTexts["War diese Antwort hilfreich?"],
			Type: MessageTypes.IGNOREINHISTORY,
			Sender: MessageSender.WILLI,
		} as Message);
		chatbotCopy.value.MessageHistory.push({
			Id: chatbotCopy.value.MessageHistory.length + 1,
			Text: "👍   " + props.company.DisplayedTexts["Ja"] + "!",
			TextSecondary: "👎  " + props.company.DisplayedTexts["Nein"],
			Type: MessageTypes.TWOBUTTONS,
			Sender: MessageSender.WILLI,
			PrimaryFunction: () => sendFeedback(1),
			SecondaryFunction: () => sendFeedback(-1),
		} as Message);

		updateScroll();

		chatbotCopy.value.Loading = false;
	}, 4000);
}

const updateScroll = async (messageIdToScrollTo?: number) => {
	await nextTick();
	await nextTick();
	const messageWindow = GetDocumentElementById("messages");
	if (messageWindow && !messageIdToScrollTo) {
		messageWindow.scrollTop = messageWindow.scrollHeight;
		return;
	}

	if (messageWindow && messageIdToScrollTo) {
		const selectedMessage = document.getElementById("message-" + messageIdToScrollTo);

		if (!selectedMessage) return;

		messageWindow.scrollTop = selectedMessage.offsetTop;
		return;
	}
}
const updateWindowHeight = () => {
	setTimeout(() => windowHeight.value = window.visualViewport?.height ?? window.innerHeight, 500)
}

const sendFeedback = async (feedback: 1 | -1) => {
	QuizService.sendChatbotQuestionFeedback(chatbotCopy.value.CurrentQuestion, feedback);

	chatbotCopy.value.MessageHistory.pop();

	chatbotCopy.value.MessageHistory.push({
		Id: chatbotCopy.value.MessageHistory.length + 1,
		Text: feedback === 1 ? "👍  " + props.company.DisplayedTexts["Ja"] + "!" : "👎  " + props.company.DisplayedTexts["Nein"],
		Type: MessageTypes.IGNOREINHISTORY,
		Sender: MessageSender.USER,
	} as Message);



	// if (props.company.CompanyQuizConfig.CouponUrl) {
	// 	chatbotCopy.value.Loading = true;
	// 	setTimeout(() => {
	// 		updateScroll();

	// 		chatbotCopy.value.MessageHistory.push({
	// 			Id: chatbotCopy.value.MessageHistory.length + 1,
	// 			Text: props.company.DisplayedTexts["Vielen Dank für dein Feedback! Möchtest du einen Rabatt für dein Lieblingsprodukt erhalten?"],
	// 			Type: MessageTypes.IGNOREINHISTORY,
	// 			Sender: MessageSender.WILLI,
	// 		} as Message);

	// 		chatbotCopy.value.MessageHistory.push({
	// 			Id: chatbotCopy.value.MessageHistory.length + 1,
	// 			Text: "👍   " + props.company.DisplayedTexts["Ja"] + "!",
	// 			TextSecondary: "👎  " + props.company.DisplayedTexts["Nein"],
	// 			Type: MessageTypes.TWOBUTTONS,
	// 			Sender: MessageSender.WILLI,
	// 			PrimaryFunction: () => {
	// 				chatbotCopy.value.Loading = true;

	// 				setTimeout(() => {
	// 					chatbotCopy.value.Loading = false;

	// 					chatbotCopy.value.MessageHistory.pop();

	// 					chatbotCopy.value.MessageHistory.push({
	// 						Id: chatbotCopy.value.MessageHistory.length + 1,
	// 						Text: "👍   " + props.company.DisplayedTexts["Ja"] + "!",
	// 						Type: MessageTypes.IGNOREINHISTORY,
	// 						Sender: MessageSender.USER,
	// 					} as Message);

	// 					chatbotCopy.value.MessageHistory.push({
	// 						Id: chatbotCopy.value.MessageHistory.length + 1,
	// 						Text: props.company.CompanyQuizConfig.CouponUrlInfo,
	// 						Type: MessageTypes.IGNOREINHISTORY,
	// 						Sender: MessageSender.WILLI,
	// 					} as Message);

	// 					chatbotCopy.value.MessageHistory.push({
	// 						Id: chatbotCopy.value.MessageHistory.length + 1,
	// 						Type: MessageTypes.COUPON,
	// 						Sender: MessageSender.WILLI,
	// 					} as Message);

	// 					updateScroll();
	// 				}, 500)
	// 			},
	// 			SecondaryFunction: () => chatFinished(),
	// 		} as Message);

	// 		updateScroll();

	// 		chatbotCopy.value.Loading = false;
	// 	}, 1000);
	// }
	// else {
	chatbotCopy.value.MessageHistory.push({
		Id: chatbotCopy.value.MessageHistory.length + 1,
		Text: props.company.DisplayedTexts["Vielen Dank für dein Feedback! Möchtest du ein weiteres Produkt finden?"],
		Type: MessageTypes.IGNOREINHISTORY,
		Sender: MessageSender.WILLI,
	} as Message);

	chatFinished();
	// }
}

const chatFinished = () => {

	chatbotCopy.value.MessageHistory.push({
		Id: chatbotCopy.value.MessageHistory.length + 1,
		Text: "❔  " + props.company.DisplayedTexts["Weiteres Produkt finden"] + " →",
		TextSecondary: "🔍  " + props.company.DisplayedTexts["Produktquiz starten"] + " →",
		Type: MessageTypes.TWOBUTTONS,
		Sender: MessageSender.WILLI,
		PrimaryFunction: () => {
			chatbotCopy.value.MessageHistory.pop();

			chatbotCopy.value.MessageHistory.push({
				Id: chatbotCopy.value.MessageHistory.length + 1,
				Text: "❔  " + props.company.DisplayedTexts["Weiteres Produkt finden"] + " →",
				Type: MessageTypes.IGNOREINHISTORY,
				Sender: MessageSender.USER,
			} as Message);

			chatbotCopy.value.Loading = true;

			setTimeout(async () => {
				chatbotCopy.value.MessageHistory.push({
					Id: chatbotCopy.value.MessageHistory.length + 1,
					Text: props.company.DisplayedTexts["Was für ein Produkt suchst du?"],
					Type: MessageTypes.NORMAL,
					Sender: MessageSender.WILLI,
				} as Message);

				updateScroll();
				inputActive.value = true;
				disableInput.value = false;
				blockChat.value = false;
				// set focus on input
				setTimeout(() => {
					if (input.value) {
						(input.value as HTMLInputElement).focus();
					}
				}, 200)
				chatbotCopy.value.Loading = false;
			}, 1000);
		},
		SecondaryFunction: () => emit("startQuiz"),
	} as Message);

	updateScroll();
}

const goBack = (e) => {
	e.preventDefault();
	chatbotCopy.value.clearHistory();
	inputActive.value = false;
	chatbotCopy.value.isExpertQuizSet = false;
	emit("goBack");
}

const chatbotTexts = computed(() => {
	return props.company.FrontendDesign?.ProductWizard?.TextConventions ?? undefined;
})

const activeInputText = computed(() => {

	if (!inputActive.value)
		return '';

	const questionExplanation = chatbotCopy.value.ExpertQuiz?.Questions.find(el => el.Id === chatbotCopy.value.ExpertQuiz?.QuestionIdHistory.at(-1))?.Explanation;
	if (chatbotCopy.value.MessageHistory[chatbotCopy.value.MessageHistory.length - 1]?.QuestionType === QuestionType.FreeTextInput && questionExplanation)
		return questionExplanation;

	return props.company.DisplayedTexts['Hier Suche eingeben'];
})

const open = (url: string) => {
	window.open(url, '_blank');
}

const showConversationStarter = computed(() => {
	return props.inputActive && !blockChat.value && activeInputText.value && !chatbotCopy.value.isExpertQuizSet
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["messageWindow", { fullscreen: props.company.CompanyQuizConfig.FullscreenMode }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.company.CompanyQuizConfig.FullscreenMode)
        ? (_openBlock(), _createBlock(ArrowLeft, {
            key: 0,
            fill: __props.company.FrontendDesign?.ProductWizard?.FontColorPrimary,
            class: "backbutton",
            onClick: goBack
          }, null, 8, ["fill"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["avatar", { center: true, border: chatbotTexts.value?.showIconBorder === 'true' }]),
          style: _normalizeStyle({ backgroundColor: __props.company.FrontendDesign?.PrimaryColor })
        }, [
          _createElementVNode("img", { src: __props.avatar }, null, 8, _hoisted_3),
          _createTextVNode(),
          _hoisted_4
        ], 6),
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(chatbotTexts.value?.name ?? "ProductWizard") + " ", 1),
          (!__props.company.CompanyQuizConfig.DemoLocation)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "powered by Agentur Philipp."))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (open('https://www.jacques.de/weindepots'))),
                  style: {"font-size":"small","cursor":"pointer","display":"flex","gap":".2em","justify-content":"center","align-items":"center"}
                }, [
                  _createVNode(Location, { color: "#fff" }),
                  _createTextVNode(_toDisplayString(__props.company.CompanyQuizConfig.DemoLocation) + " ", 1),
                  _createVNode(Arrow, {
                    color: "#fff",
                    style: {"rotate":"90deg"}
                  })
                ])
              ]))
        ])
      ]),
      _createVNode(Close, {
        class: "close",
        fill: __props.company.FrontendDesign?.SecondaryColor,
        onClick: _cache[1] || (_cache[1] = (e) => {
		if (__props.company.CompanyQuizConfig.FullscreenMode)
			goBack(e);
		else emit('closeChatWindow')
	})
      }, null, 8, ["fill"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "messages",
        id: "messages",
        style: _normalizeStyle({ height: showConversationStarter.value ? 'calc(100% - 85px)' : '100%' })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatbotCopy.value.MessageHistory, (message) => {
          return (_openBlock(), _createBlock(SingleMessage, {
            message: message,
            key: message.Id,
            company: __props.company,
            productRecommendation: message.ProductRecommendations,
            chatbot: (chatbotCopy.value as Chatbot),
            ref_for: true,
            ref: message.Id.toString(),
            id: 'message-' + message.Id,
            avatar: __props.avatar,
            onProductClicked: _cache[2] || (_cache[2] = product => {isDialogOpened.value = true; selectedProduct.value = product}),
            onStartQuiz: _cache[3] || (_cache[3] = ($event: any) => (emit('startQuiz'))),
            onHardStartQuiz: _cache[4] || (_cache[4] = ($event: any) => (emit('hardStartQuiz'))),
            isExpertQuiz: __props.isExpertQuiz
          }, null, 8, ["message", "company", "productRecommendation", "chatbot", "id", "avatar", "isExpertQuiz"]))
        }), 128))
      ], 4),
      (chatbotCopy.value.Loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(Typing)
          ]))
        : _createCommentVNode("", true),
      (isDialogOpened.value)
        ? (_openBlock(), _createBlock(DialogComponent, {
            key: 1,
            onClose: _cache[7] || (_cache[7] = ($event: any) => (isDialogOpened.value = false)),
            class: "dialog"
          }, {
            default: _withCtx(() => [
              (__props.company.CompanyQuizConfig.ResultButtonAction !== 'OPENNAVIGATIONMAP')
                ? (_openBlock(), _createBlock(EmailForm, {
                    key: 0,
                    company: __props.company,
                    class: "emailChoice",
                    onClose: _cache[5] || (_cache[5] = ($event: any) => {
					isDialogOpened.value = false;}),
                    onReject: _cache[6] || (_cache[6] = ($event: any) => (isDialogOpened.value = false)),
                    rejectText: "Schließen",
                    confirmText: "Absenden",
                    infoText: __props.company.CompanyQuizConfig.EmailDialogText ?? undefined,
                    chatbot: (chatbotCopy.value as Chatbot)
                  }, null, 8, ["company", "infoText", "chatbot"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (showConversationStarter.value && __props.company.DisplayedTexts['supersearchExamples'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(__props.company.DisplayedTexts["Vorschläge"] ?? "Vorschläge") + " :", 1))
        : _createCommentVNode("", true),
      (showConversationStarter.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.company.DisplayedTexts['supersearchExamples'], (example) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "secondary small op-75",
                onClick: ($event: any) => (actionExampleClicked(example)),
                key: example
              }, _toDisplayString(example), 9, _hoisted_13))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (chatbotCopy.value.MessageHistory.at(-1)?.Text !== 'Neu laden')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: activeInputText.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((question).value = $event)),
              onKeyup: _withKeys(sendMessage, ["enter"]),
              disabled: (!inputActive.value || blockChat.value) && disableInput.value,
              ref_key: "input",
              ref: input,
              autofocus: "",
              onFocus: _cache[9] || (_cache[9] = ($event: any) => (updateWindowHeight())),
              onBlur: _cache[10] || (_cache[10] = ($event: any) => (updateWindowHeight()))
            }, null, 40, _hoisted_15), [
              [_vModelText, question.value]
            ]),
            _createVNode(PaperPlane, {
              hoverColor: "#1d74f5",
              onClick: sendMessage
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})